import { findLast } from "@foretagsplatsen/core-helpers/array";
import { isNotNull } from "../../core/helpers/object-util.js";
import Model from "../Model.js";

/**
 * `AnnualTrend` is a class showing how some values evolve during
 * a year.
 *
 * @param {number[]} spec.profitTrend - .
 * @param {number[]} spec.accumulatedProfitTrend -
 * @param {number[]} spec.incomeTrend -
 * @param {number[]} spec.accumulatedIncomeTrend -
 * @param {string[]} spec.periodLabels - E.g., ['Jan', 'Feb', ...]
 */
export default class AnnualTrend extends Model {
	constructor(spec) {
		super(spec);
		this.profitTrend = spec.profitTrend.slice();
		this.accumulatedProfitTrend = spec.accumulatedProfitTrend.slice();
		this.incomeTrend = spec.incomeTrend.slice();
		this.accumulatedIncomeTrend = spec.accumulatedIncomeTrend.slice();

		this.periodLabels = spec.periodLabels.slice();
	}

	// TODO: periods should be set from the outside
	// or at creation time, or just after
	getValuesForPeriod(period, periods) {
		return {
			profit: this._sumValuesForPeriod(this.profitTrend, period),
			income: this._sumValuesForPeriod(this.incomeTrend, period),
			"accumulated-profit": this._lastValueInPeriod(
				this.accumulatedProfitTrend,
				period,
				periods,
			),
			"accumulated-income": this._lastValueInPeriod(
				this.accumulatedIncomeTrend,
				period,
				periods,
			),
		};
	}

	_sumValuesForPeriod(values, period) {
		return period
			.asMonths()
			.map((month) => values[month.getPeriodIndex() - 1])
			.reduce((a, b) => a + b);
	}

	_lastValueInPeriod(values, period, periods) {
		const index = periods.indexOf(period.lastMonth());
		const trimmedValues = values.slice(0, index + 1);

		return findLast(trimmedValues, isNotNull);
	}
}
